import { PrivacyPolicySettingId, isOcpsPolicyEnabled } from 'owa-owsprime-policies-store';
import {
    isOcpsPolicyEnabled as isOcpsPolicyEnabledLegacy,
    OcpsPolicy,
} from 'owa-ocps-policy-store';
import { isAccountFeatureEnabled } from 'owa-feature-flags';
import { isPrivacyRoamingEnabled } from './isPrivacyRoamingEnabled';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';

export const getOptionalExperiencesPolicy = (): boolean => {
    if (!isPrivacyRoamingEnabled()) {
        return true;
    }

    const mailboxInfo = getGlobalSettingsAccountMailboxInfo();

    if (isAccountFeatureEnabled('policy-ocps-owsprime', mailboxInfo)) {
        return isOcpsPolicyEnabled(
            PrivacyPolicySettingId.OptionalConnectedExperiences,
            mailboxInfo,
            true /* enabledIfUndefined */
        );
    }

    return isOcpsPolicyEnabledLegacy(
        OcpsPolicy.OptionalConnectedExperiences,
        true /* enabledIfUndefined */,
        mailboxInfo
    );
};
